import {Loader, Container, Card, Text} from "@mantine/core";
import React from "react";

export function ContainerLoader() {
    return (
        <center>
            <Container p={"lg"}>
                <Card shadow="sm" padding="lg" radius="md" withBorder>
                    <Text align={'center'} size={42}><Loader size="lg" variant="bars"/> Loading...</Text>
                </Card>
            </Container>
        </center>
    )
}